const apply = [
  {
    path: '/approval/apply/allmenu',
    component: () => import('@/page/approval/apply/AllMenuApply.vue'),
    meta: {
      name: '전체',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/approval/apply/vacation',
    component: () => import('@/page/approval/apply/VacationApply.vue'),
    meta: {
      name: '휴가 신청',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/approval/apply/workhome',
    component: () => import('@/page/approval/apply/WorkHomeApply.vue'),
    meta: {
      name: '재택근무 신청',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/approval/apply/outside',
    component: () => import('@/page/approval/apply/OutsideApply.vue'),
    meta: {
      name: '출장 및 외근 신청',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/approval/apply/mealcost',
    component: () => import('@/page/approval/apply/MealCostApply.vue'),
    meta: {
      name: '식대비 신청',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/approval/apply/expense',
    component: () => import('@/page/approval/apply/ExpenseApply.vue'),
    meta: {
      name: '지출결의서 신청',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/approval/apply/submit',
    component: () => import('@/page/approval/apply/SubmitApply.vue'),
    meta: {
      name: '품의서 신청',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/approval/apply/holidaywork',
    component: () => import('@/page/approval/apply/HolidayWorkApply.vue'),
    meta: {
      name: '휴일근무 신청',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/approval/apply/admit',
    component: () => import('@/page/approval/apply/AdmitApply.vue'),
    meta: {
      name: '인정휴가 지급 신청',
      isActive: false,
      isBread: true,
    },
  },
  {
    path: '/approval/apply/businesstrip',
    component: () => import('@/page/approval/apply/BusinessTripApply.vue'),
    meta: {
      name: '출장결과보고서 신청',
      isActive: false,
      isBread: true,
    },
  },
];

export default apply;
